import { Reveal } from "./Reveal";

// Consistent inner-page hero header.
export default function PageHeader({ eyebrow, title, sub }) {
  return (
    <section className="relative mx-auto max-w-7xl px-5 pt-16 pb-8 text-center" data-testid="page-header">
      <div className="aurora-blob" style={{ width: 300, height: 300, top: "-20%", left: "40%", background: "radial-gradient(circle, color-mix(in srgb, var(--brand-2) 55%, transparent), transparent 65%)", opacity: 0.3 }} />
      <Reveal className="relative">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 rounded-full glass px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand">{eyebrow}</span>
        )}
        <h1 className="mx-auto mt-5 max-w-3xl text-4xl font-bold text-slate-900 sm:text-5xl lg:text-6xl">{title}</h1>
        {sub && <p className="mx-auto mt-4 max-w-2xl text-base text-slate-500 sm:text-lg">{sub}</p>}
      </Reveal>
    </section>
  );
}
